import React from 'react';
import Image from 'next/image';
import {motion, MotionValue} from 'motion/react';

import styles from './avatar-row.module.scss';
import {useAvatarScroll} from '../../hooks/use-avatar-scroll';
import {useScrollState} from '../../hooks/use-scroll-state';

interface AvatarData {
    url: string;
    id?: number;
}

interface AvatarRowProps {
    avatars: AvatarData[];
    scrollProgress?: MotionValue<number>;
}

export const AvatarRow: React.FC<AvatarRowProps> = ({avatars, scrollProgress}) => {
    const {isStatic, effectiveScrollProgress} = useScrollState(scrollProgress);

    const scrollAnimations = useAvatarScroll(effectiveScrollProgress);
    const {avatarX, containerScale} = isStatic ? {avatarX: 0, containerScale: 1} : scrollAnimations;

    const displayAvatars = isStatic ? avatars : [...avatars, ...avatars];

    if (isStatic) {
        return (
            <div className={styles['avatar-row']}>
                <div className={styles['avatar-scroll-container']}>
                    {displayAvatars.map(({url}, id) => (
                        <div key={`avatar-wrapper-${id}`} className={styles['avatar-wrapper']}>
                            <Image
                                src={url}
                                alt="Avatar"
                                width={100}
                                height={100}
                                className={styles.avatar}
                            />
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className={styles['avatar-row']}>
            <motion.div
                className={styles['avatar-scroll-container']}
                style={{
                    x: avatarX,
                    scale: containerScale,
                }}
            >
                {displayAvatars.map(({url}, id) => (
                    <div key={`avatar-wrapper-${id}`} className={styles['avatar-wrapper']}>
                        <Image
                            src={url}
                            alt="Avatar"
                            width={100}
                            height={100}
                            className={styles.avatar}
                        />
                    </div>
                ))}
            </motion.div>
        </div>
    );
};
